import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DISPLAY_STATUS, STATUS_OBJECT } from 'src/app/dummy/status';
import { TABS } from 'src/app/dummy/tab';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { MatDialog } from '@angular/material';
import { AddPosWordComponent } from './add-pos-word/add-pos-word.component';

@Component({
  selector: 'app-dictionary',
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.scss']
})
export class DictionaryPageComponent implements OnInit {

  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  displayStatus = DISPLAY_STATUS
  tabs = TABS.DICTIONARY;
  page: any;
  status: any;
  search: any;
  size = APPS.SIZE
  DISPLAY_STATUS_KEY: any;
  searchTextBox = new FormControl(null, []);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog

  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchData('dictionary',this.DISPLAY_STATUS_KEY.key, selectedCompanyKey)
    })
  }

  create() {
    this.router.navigate([`/dictionary/dictionary-form/draft`])
  }


  createMorePOS(item) {
    let dialogRef = this.dialog.open(AddPosWordComponent, {
      data:item,
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
